import { render, staticRenderFns } from "./AdminRoutePage.vue?vue&type=template&id=a515b91c&"
import script from "./AdminRoutePage.vue?vue&type=script&lang=js&"
export * from "./AdminRoutePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports